import i18n from '../../i18n';

export const translations = {
  credit: {
    label: i18n.t(`account-transaction-management.type.table.credit`),
    color: 'bg-success-subtle text-success',
  },
  debit: {
    label: i18n.t(`account-transaction-management.type.table.debit`),
    color: 'bg-danger-subtle text-danger',
  },
};

export const indetifierTypeTranslations = {
  wallet_withdrawal: {
    label: i18n.t(`account-transaction-management.identifier-type.table.wallet_withdrawal`),
    color: 'bg-info-subtle text-info',
  },
  manual_operation: {
    label: i18n.t(`account-transaction-management.identifier-type.table.manual_operation`),
    color: 'bg-info-subtle text-info',
  },
  'null': {
    label: '-',
    color: 'bg-info-subtle text-info',
  },
};
